import Botao from '@/components/Botao';
import CampoSeletor from '@/components/Formulario/CampoSeletor';
import HBox from '@/components/layout/HBox';
import { mdiPlus } from '@mdi/js';
import axios from 'axios';
import { useQuery } from 'react-query';

type CampoSeletorEmpresaProps = {
  instanceId?: string;
  value: number | null | undefined;
  onChange: (v: number | null) => void;
  onNovaEmpresa?: () => void;
  label: string;
  error: string | undefined;
  nullable?: boolean;
};

export const CampoSeletorEmpresa = ({
  instanceId,
  value,
  onChange,
  onNovaEmpresa,
  label,
  error,
  nullable
}: CampoSeletorEmpresaProps) => {
  const q = useQuery('empresa/box', async () => {
    const result = await axios.get('/api/empresa/box');
    return result.data.result;
  });

  const options = q.data?.map((e: any) => ({
    id: e.id,
    label: e.nome_fantasia ? (e.nome_fantasia.toLowerCase().localeCompare(e.razao_social.toLowerCase()) ? `${e.nome_fantasia} (${e.razao_social})` : e.nome_fantasia) : e.razao_social
  })) ?? [];

  return (
    <HBox style={{ alignItems: 'flex-end' }}>
      <CampoSeletor
        instanceId={instanceId}
        nullable={nullable}
        options={options}
        value={value?.toString()}
        onChange={v => onChange(v == null || v === '' ? null : +v)}
        label={label}
        error={error}
      />
      {onNovaEmpresa && (
        <Botao
          variant="outline-primary"
          title="Nova Empresa"
          onClick={onNovaEmpresa}
          icon={mdiPlus}
        />
      )}
    </HBox>
  );
};
